import { createSearchParamsSelectors } from '../../packages/searchParamsManager';

export const searchParamKeys = {
  company: 'cmpn',
  view: 'view',
  calendarMode: 'clndrMode',
  calendarPage: 'clndrPg',
  acceptance: 'acptnc',
  showClient: 'shwClnt',
  showAddress: 'shwAddr',
  roomsTableHasRelations: 'rmTblHsRltns',
  roomsTableType: 'rmTblTp',
  roomsTableStage: 'rmTblStg',
  roomsTableStep: 'rmTblStp',
  roomsTableStatus: 'rmTblSts',
  roomsTableService: 'rmTblSvc',
  roomsTableDesk: 'rmTblDsk',
  roomsTablePorch: 'rmTblPrch',
  roomsTableRecordDate: 'rmTblRcrdDt',
  roomsTableSortKey: 'rmTblSrtKy',
  roomsTableSortOrder: 'rmTblSrtOrdr',
  roomsTablePage: 'rmTblPg',
  roomsTablePageSize: 'rmTblPgSz',
  roomsTableRepeat: 'rmTblRpt',
  roomsTableFlatNumber: 'rmTblFltNmbr',
  roomsTableAddressDdu: 'rmTblAddrDdu',
  roomsTableNumberDdu: 'rmTblNmbrDdu',
  roomsTableFinishType: 'rmTblFnshTp',
  detailsPageMode: 'dtlsPgMd',
  detailedInfoRoomId: 'dtldInfRmId',
};

export const searchParamSelectors = createSearchParamsSelectors(
  Object.values(searchParamKeys)
);

// bool
export const booleanMap = {
  yes: 'y',
  no: 'n',
};
export const booleans = Object.values(booleanMap);

// view
export const viewMap = {
  calendar: 'clndr',
  list: 'lst',
};
export const views = Object.values(viewMap);
export const defaultView = viewMap.list;

// calendar view
export const calendarModeMap = {
  month: 'mth',
  week: 'wk',
  day: 'dy',
  gant: 'gnt',
};
export const calendarModes = Object.values(calendarModeMap);
export const defaultCalendarMode = calendarModeMap.week;

// details page
export const detailsPageModeMap = {
  view: 'vw',
  registration: 'rgsrtn',
  reRegistration: 'rRgsrtn',
};
export const detailsPageModes = Object.values(detailsPageModeMap);
export const defaultDetailsPageMode = detailsPageModeMap.view;
export const detailsPageRegisterModes = new Set([
  detailsPageModeMap.registration,
  detailsPageModeMap.reRegistration,
]);

export const roomsTableSearchParamKeys = [
  searchParamKeys.roomsTableHasRelations,
  searchParamKeys.roomsTableType,
  searchParamKeys.roomsTablePorch,
  searchParamKeys.roomsTableStage,
  searchParamKeys.roomsTableStep,
  searchParamKeys.roomsTableStatus,
  searchParamKeys.roomsTableService,
  searchParamKeys.roomsTableDesk,
  searchParamKeys.roomsTableSortKey,
  searchParamKeys.roomsTableSortOrder,
  searchParamKeys.roomsTableRepeat,
  searchParamKeys.roomsTableFlatNumber,
  searchParamKeys.roomsTableAddressDdu,
];

export const resettableParams = {
  [searchParamKeys.calendarPage]: undefined,
  [searchParamKeys.roomsTableHasRelations]: undefined,
  [searchParamKeys.roomsTableType]: undefined,
  [searchParamKeys.roomsTableStage]: undefined,
  [searchParamKeys.roomsTableStep]: undefined,
  [searchParamKeys.roomsTableStatus]: undefined,
  [searchParamKeys.roomsTableService]: undefined,
  [searchParamKeys.roomsTableDesk]: undefined,
  [searchParamKeys.roomsTablePorch]: undefined,
  [searchParamKeys.roomsTablePage]: 1,
  [searchParamKeys.roomsTableRepeat]: undefined,
  [searchParamKeys.roomsTableFlatNumber]: undefined,
  [searchParamKeys.roomsTableAddressDdu]: undefined,
  [searchParamKeys.roomsTableNumberDdu]: undefined,
  [searchParamKeys.roomsTableRecordDate]: undefined,
};
